enum DocumentTypes {
  dni= 'DNI',
  pasaporte= 'PASAPORTE',
}

export const DocumentTypesList = Object.entries(DocumentTypes).map(([, value]) => ({
  label: value,
  value
}));

export default DocumentTypes;
